import React from 'react'
import moment from 'moment'
import { capitalize, get } from 'lodash'

const EMPTY_PLACEHOLDER = '-'

/**
 * Updated Date Custom Cell Component
 * @param date
 * @returns {string}
 * @constructor
 */
const UpdatedDateCell = ({ date }) => {
  return date ? moment.utc(date).format('MM/DD/YYYY') : EMPTY_PLACEHOLDER
}

/**
 * Custom Cell Render
 * @param data
 * @param column
 * @returns {*}
 */
const CustomCell = ({ data = {}, column = {} }) => {
  const cellData = data[column.colId]
  const job = get(data, 'jobs[0]')
  const name = []
    .concat(data.first_name, data.last_name)
    .filter((name) => name && name.trim()).join(' ')

  switch (column.colId) {
    case 'source':
    case 'status':
      return (cellData === 'gdpr' || cellData === 'dnq')
        ? cellData.toUpperCase()
        : (cellData === 'onleave')
          ? 'OnLeave'
          : capitalize(cellData) || EMPTY_PLACEHOLDER
    case 'full_name':
      return name || EMPTY_PLACEHOLDER
    case 'institution':
      return get(job, 'institution_name') || EMPTY_PLACEHOLDER
    case 'title':
      return get(job, 'title') || EMPTY_PLACEHOLDER
    case 'functions':
      const functions = get(job, 'functions')
      return functions ? []
        .concat(functions)
        .filter((option) => option && option.trim()).join(', ') : EMPTY_PLACEHOLDER
    case 'updated_date':
      return <UpdatedDateCell date={cellData} />

    default:
      return cellData || EMPTY_PLACEHOLDER
  }
}

export default CustomCell
